import React from 'react';
import { FullscreenExitOutlined, FullscreenOutlined } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';

import { IPlayerProps } from '../../../types/player';
import { useTranslation } from 'react-i18next';

function FullscreenToggle(props: any) {
  const slice = { ...props } as IPlayerProps;
  const { actions, player, manager } = slice;
  const { t } = useTranslation();

  const controlText = player.isFullscreen
    ? t('stream.controlBar.fullScreen.true')
    : t('stream.controlBar.fullScreen.false');

  const handleClick = () => {
    const { video, rootElement } = manager;

    if (player.error || !video?.hls) return;

    actions.toggleFullscreen(rootElement, player);
  };

  return (
    <Box>
      <Tooltip
        title={controlText}
        placement="top-end"
        PopperProps={{
          disablePortal: true,
        }}
      >
        <IconButton onClick={handleClick}>
          {player.isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default FullscreenToggle;
